// src/components/ChatBox.jsx
import React, { useState, useRef, useEffect } from "react";

const ChatBox = ({ onSend }) => {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const bottomRef = useRef(null);

  const handleSend = async () => {
    if (!input.trim()) return;

    const userMsg = { sender: "user", text: input };
    setMessages((msgs) => [...msgs, userMsg]);

    try {
      const botResponse = await onSend(input);
      addBotMessage(botResponse);
    } catch (error) {
      addBotMessage("⚠️ Oops! Something went wrong.");
    }

    setInput("");
  };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const addBotMessage = (text) => {
    const botMsg = { sender: "bot", text };
    setMessages((msgs) => [...msgs, botMsg]);
  };

  return (
    <div className="flex flex-col h-[calc(100vh-6rem)] w-full md:max-w-4xl mx-auto border border-gray-300 rounded-lg shadow-lg bg-white">
      {/* Messages Area */}
      <div className="flex-grow p-3 md:p-4 overflow-y-auto space-y-3 md:space-y-4">
        {messages.length === 0 && (
          <p className="text-center text-gray-400 text-sm md:text-base">
            Start solving the question...
          </p>
        )}
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`flex ${
              msg.sender === "user" ? "justify-end" : "justify-start"
            }`}
          >
            <div
              className={`rounded-lg px-3 py-2 md:px-4 md:py-2 max-w-[80%] md:max-w-lg whitespace-pre-wrap text-sm md:text-base leading-relaxed ${
                msg.sender === "user"
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-900 border border-gray-300"
              }`}
            >
              {msg.text}
            </div>
          </div>
        ))}
        <div ref={bottomRef}></div>
      </div>

      {/* Input Area */}
      <div className="flex flex-col md:flex-row border-t border-gray-300 p-3 md:p-4 gap-2 md:gap-4">
        <textarea
          className="flex-grow border border-gray-300 rounded-md p-2 resize-none focus:outline-none focus:ring-2 focus:ring-blue-600 text-sm md:text-base"
          rows={2}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your answer or request here..."
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSend();
            }
          }}
        />
        <button
          onClick={handleSend}
          className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition text-sm md:text-base"
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default ChatBox;
